import React, { useEffect, useState } from 'react'
import { Button, Card, Col, Container, Form, Pagination, Row, Table } from 'react-bootstrap'
import * as XLSX from 'xlsx';
import * as fs from 'file-saver'
import { Workbook } from 'exceljs'
import ManagePackageService from '../services/ManagePackageService';
import { isObjectValid } from '../common/utils/validate';
import Loading from '../components/loading/Loading';
import SweetAlert2 from 'react-sweetalert2';
import { useNavigate } from 'react-router-dom';

const provicnes = ["กรุงเทพมหานคร", "กระบี่", "กาญจนบุรี", "กาฬสินธุ์", "กำแพงเพชร", "ขอนแก่น", "จันทบุรี", "ฉะเชิงเทรา", "ชลบุรี", "ชัยนาท", "ชัยภูมิ", "ชุมพร", "เชียงราย", "เชียงใหม่", "ตรัง", "ตราด", "ตาก", "นครนายก", "นครปฐม", "นครพนม", "นครราชสีมา", "นครศรีธรรมราช", "นครสวรรค์", "นนทบุรี", "นราธิวาส", "น่าน", "บึงกาฬ", "บุรีรัมย์", "ปทุมธานี", "ประจวบคีรีขันธ์", "ปราจีนบุรี", "ปัตตานี", "พระนครศรีอยุธยา", "พังงา", "พัทลุง", "พิจิตร", "พิษณุโลก", "เพชรบุรี", "เพชรบูรณ์", "แพร่", "พะเยา", "ภูเก็ต", "มหาสารคาม", "มุกดาหาร", "แม่ฮ่องสอน", "ยะลา", "ยโสธร", "ร้อยเอ็ด", "ระนอง", "ระยอง", "ราชบุรี", "ลพบุรี", "ลำปาง", "ลำพูน", "เลย", "ศรีสะเกษ", "สกลนคร", "สงขลา", "สตูล", "สมุทรปราการ", "สมุทรสงคราม", "สมุทรสาคร", "สระแก้ว", "สระบุรี", "สิงห์บุรี", "สุโขทัย", "สุพรรณบุรี", "สุราษฎร์ธานี", "สุรินทร์", "หนองคาย", "หนองบัวลำภู", "อ่างทอง", "อุดรธานี", "อุทัยธานี", "อุตรดิตถ์", "อุบลราชธานี", "อำนาจเจริญ"]

function SearchMember() {

    const navigate = useNavigate()

    const [dataMember, setDataMember] = useState({})
    const [page, setPage] = useState(1)

    const [dataInput, setDataInput] = useState({
        province: '',
        corunty: 'ไทย'
    })
    const [searchCondition, setSearchCondition] = useState({
        province: '',
        corunty: 'ไทย'
    })
    const [isFirstLoad, setIsFirstLoad] = useState(false)
    useEffect(() => {
        if (isFirstLoad) {
            onSearch()

        }
        else {
            setIsFirstLoad(true)
        }

    }, [page])

    const [isLoading, setIsLoading] = useState(false)
    const [swalProps, setSwalProps] = useState({});



    return (
        <div className='home-body font-link '>

            <Container>

                <Row>
                    <Col>
                        <Card>
                            <Card.Body>
                                <label style={{ fontSize: 16, fontWeight: 'bold', textDecorationLine: 'underline' }} >ระบุเงื่อนไขการค้นหา</label>

                                <Row className='mt-4' style={{ alignItems: 'center' }}>

                                    <Col xs={2}>
                                        <label>ประเทศ</label>
                                    </Col>
                                    <Col xs={3}>
                                        <Form.Select
                                            onChange={(e) => {

                                                // alert(e.target.value)
                                            }}
                                        >
                                            <option value="ไทย">ไทย</option>

                                        </Form.Select>
                                    </Col>

                                    <Col xs={2}>
                                        <label>จังหวัด</label>
                                    </Col>
                                    <Col xs={3}>
                                        <Form.Select
                                            onChange={(e) => {

                                                setDataInput(prevState => ({
                                                    ...prevState, province: e.target.value
                                                }))
                                            }}
                                        >
                                            <option selected={dataInput.province === '' ? true : false}>กรุณาเลือก</option>
                                            {provicnes.map(item => {
                                                return <option value={item}>{item}</option>
                                            })}

                                        </Form.Select>
                                    </Col>


                                </Row>


                                <Row className='mt-4'>
                                    <div style={{ flexDirection: 'row' }}>

                                        <Button variant="primary" onClick={(e) => {

                                            onSearch(true)

                                        }}>Search</Button>


                                        <Button style={{ marginLeft: 10 }} variant="outline-secondary" onClick={() => {
                                            onReset()
                                        }}>Reset</Button>

                                    </div>

                                </Row>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>

                {isObjectValid(dataMember) &&
                    <Row>
                        <Col>
                            <Card>
                                <Card.Body>
                                    <Row>
                                        <Col xs={12}>
                                            <label style={{ fontSize: 16, fontWeight: 'bold', textDecorationLine: 'underline' }} >รายชื่อจำนวนทั้งหมด {dataMember.totalCount}</label>
        
                                        </Col>
                         
                                    </Row>
                                    {/* <Row>
                                        <Col xs={2}>
                                            <label >จังหวัด {searchCondition.province}</label>
                                        </Col>
                                        <Col xs={2}>
                                            <label >ประเทศ {searchCondition.corunty}</label>

                                        </Col>
                                    </Row> */}
                                    <Row className='mt-2'>


                                        {/* <label style={{ fontSize: 16, fontWeight: 'bold', textDecorationLine: 'underline' }} >จำนวนทั้งหมด {dataMember.totalCount} </label> */}
                                        <Col className='mt-4'>
                                            <Table striped bordered hover size="sm">
                                                <thead>
                                                    <tr>
                                                        <th>#</th>
                                                        <th>Phone Number</th>
                                                        <th>Name</th>

                                                    </tr>
                                                </thead>
                                                <tbody>


                                                    {isObjectValid(dataMember) && dataMember.items.map((item, index) => {

                                                        return (
                                                            <tr>
                                                                <td>{(index + 1) + ((page - 1) * 50)}</td>
                                                                <td>{item.telephone}</td>
                                                                <td>{`${item.prefix} ${item.firstName} ${item.lastName}`}</td>
                                                            </tr>
                                                        )
                                                    })}

                                                </tbody>
                                            </Table>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col>
                                            <Pagination>

                                                {getPageTotal()}

                                            </Pagination>
                                        </Col>
                                    </Row>
                                </Card.Body>
                            </Card>
                        </Col>
                    </Row>
                }



            </Container>

            <Loading isShow={isLoading} />

            <SweetAlert2 {...swalProps}

                didClose={() => {
                    setSwalProps({
                        show: false,
                        icon: 'info',
                        html: 'กรุณากรอกข้อมูลให้ถูกต้อง',
                        showConfirmButton: true,
                        confirmButtonColor: '#0d6efd',
                        confirmButtonText: 'OK',
                    });
                }}

                onConfirm={result => {
                    setSwalProps({
                        show: false,
                        icon: 'info',
                        html: 'กรุณากรอกข้อมูลให้ถูกต้อง',
                        showConfirmButton: true,
                        confirmButtonColor: '#0d6efd',
                        confirmButtonText: 'OK',
                    });
                }}


            />

        </div>
    )


    function onReset() {


        setDataMember({})


        setDataInput({
            province: '',
            corunty: 'ไทย'
        })


    }

    async function onSearch(isNew = false) {

        // if (dataInput.corunty !== '' && dataInput.province !== '') {

            if(isNew)
                setPage(1)

            let params = new URLSearchParams()

            params.append('province', dataInput.province === 'กรุณาเลือก' ? '' : dataInput.province)
            params.append('page', isNew ? 1 : page)
            params.append('pageSize', 50)

            setIsLoading(true)
            ManagePackageService.searchMember(params).then(result => {
                setIsLoading(false)

                if (result.status === 200) {
                    setSearchCondition({
                        province: dataInput.province,
                        corunty: dataInput.corunty
                    })
                    setDataMember(result.data)
                    console.log(result.data)
                }
            }).catch(err => {
                setIsLoading(false)
    
    
                if (err.status === 401) {
                    navigate('/login')
                }
    
            })
    


        // }
        // else {
        //     setSwalProps({
        //         show: true,
        //         icon: 'info',
        //         html: 'กรุณากรอกข้อมูลให้ถูกต้อง',
        //         showConfirmButton: true,
        //         confirmButtonColor: '#0d6efd',
        //         confirmButtonText: 'OK',
        //     });

        // }
    }
    function onNext() {

        setPage(page + 1)
    }
    function onPrev() {
        setPage(page - 1)
    }

    function getPageTotal() {
        let array = []

        for (let i = page; i <= page + 5; i++) {
            if (i <= dataMember.totalPage) {

                array.push(<Pagination.Item onClick={() => {
                    setPage(i)
                }} active={page === i ? true : false} >
                    {i}
                </Pagination.Item>)
            }
        }

        if (array.length !== 5) {
            if (page > 1) {
                for (let i = page - 1; i >= page - (5 - array.length); i--) {

                    if (i >= 1) {
                        array.unshift(<Pagination.Item onClick={() => {
                            setPage(i)
                        }} active={page === i ? true : false} >
                            {i}
                        </Pagination.Item>)
                    }
                }
            }
        }


        array.unshift(<Pagination.Item onClick={() => {
            onPrev()
        }}  >
            Prev
        </Pagination.Item>)




        array.push(<Pagination.Item onClick={() => {
            onNext()
        }}  >
            Next
        </Pagination.Item>)



        // for (let i = 1; i <= dataMember.totalPage; i++) {
        //     array.push(
        //         <Pagination.Item onClick={() => {
        //             setPage(i)
        //         }} key={`key-${i}`} active={page === i ? true : false} >
        //             {i}
        //         </Pagination.Item>
        //     )
        // }
        return array
    }

}

export default SearchMember